import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HistoryResultComponent } from "./history-result/history-result.component";
import { HistoryComponent } from "./history/history.component";
import { HomeComponent } from "./home/home.component";
import { ResultNSLComponent } from "./result-nsl/result-nsl.component";
import { ResultNSLEntityComponent } from "./result-nsl-entity/result-nsl-entity.component";
import { ResultSanctionComponent } from "./result-sanction/result-sanction.component";
import { ResultEntityComponent } from "./result-entity/result-entity.component";
import { ResultCriminalComponent } from "./result-criminal/result-criminal.component";
import { ResultComponent } from "./result/result.component";
import { SearchListComponent } from "./search-list/search-list.component";
import { SearchComponent } from "./search/search.component";
import { SettingComponent } from "./setting/setting.component";
import { SanctionHistoryResultComponent } from "./sanction-historyresult/sanction-historyresult.component";
import { EntityResultHistoryComponent } from "./entity-historyresult/entity-historyresult.component";
import { NSLHistoryResultComponent } from "./nsl-historyresult/nsl-historyresult.component";
import { NSLEntityHistoryResultComponent } from "./nsl-entity-historyresult/nsl-entity-historyresult.component";
import { LoginComponent } from "./user-pages/login/login.component";
import { AuthGuardService } from "./auth-guard.service";
import { AdminAuthGuardService } from "./admin-auth-guard.service";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { AllCompaniesComponent } from "./all-companies/all-companies.component";
import { AllUsersComponent } from "./all-users/all-users.component";
import { NewCompanyComponent } from "./new-company/new-company.component";
import { EditCompanyComponent } from "./edit-company/edit-company.component";
import { ViewCompanyComponent } from "./view-company/view-company.component";
import { ViewUserComponent } from "./view-user/view-user.component";
import { EditUserComponent } from "./edit-user/edit-user.component";
import { NewUserComponent } from "./new-user/new-user.component";
import { AllAdminsComponent } from "./all-admins/all-admins.component";
import { ViewAdminComponent } from "./view-admin/view-admin.component";
import { EditAdminComponent } from "./edit-admin/edit-admin.component";
import { NewAdminComponent } from "./new-admin/new-admin.component";
import { CreditHistoryComponent } from "./credit-history/credit-history.component";
import { PrintComponent } from "./print/print.component";
import { NewPrintComponent } from "./new-print/new-print.component";
import { NewPrintHistoryComponent } from "./new-print-history/new-print-history.component";
import { PartnerLoginTestComponent } from "./partner-login-test/partner-login-test.component";
import { PartnerSearchTestComponent } from "./partner-search-test/partner-search-test.component";
import { PartnerAdvanceSearchTestComponent } from "./partner-advance-search-test/partner-advance-search-test.component";
import { ResultAdverseMediaComponent } from "./result-adverse-media/result-adverse-media.component";
import { ResultAdverseMediaCategoryComponent } from "./result-adverse-media-category/result-adverse-media-category.component";
import { ResultAdverseMediaArticleComponent } from "./result-adverse-media-article/result-adverse-media-article.component";
import { NewPrintMediaComponent } from "./new-print-media/new-print-media.component";

const routes: Routes = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  // { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  // { path: 'dashboard', component: DashboardComponent },
  { path: "home", component: HomeComponent, canActivate: [AuthGuardService] },
  {
    path: "search",
    component: SearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "searchlist/:name",
    component: SearchListComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result",
    component: ResultComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-sanction",
    component: ResultSanctionComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-nsl",
    component: ResultNSLComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-nsl-entity",
    component: ResultNSLEntityComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-entity",
    component: ResultEntityComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-criminal",
    component: ResultCriminalComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-adverse-media",
    component: ResultAdverseMediaComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-adverse-media-category",
    component: ResultAdverseMediaCategoryComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "result-adverse-media-article",
    component: ResultAdverseMediaArticleComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "historyresult",
    component: HistoryResultComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "sanction-historyresult",
    component: SanctionHistoryResultComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "entity-historyresult",
    component: EntityResultHistoryComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "nsl-historyresult",
    component: NSLHistoryResultComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "nsl-entity-historyresult",
    component: NSLEntityHistoryResultComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "history",
    component: HistoryComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "setting",
    component: SettingComponent,
    canActivate: [AuthGuardService],
  },
  { path: "user-pages/login", component: LoginComponent },
  // Partner test page (no auth guard)
  { path: "partner-login-test", component: PartnerLoginTestComponent },
  // Partner search test page (no auth guard)
  { path: "partner-search-test", component: PartnerSearchTestComponent },
  // Partner advance search test page (no auth guard)
  { path: "partner-advance-search-test", component: PartnerAdvanceSearchTestComponent },
  {
    path: "admin-dashboard",
    component: AdminDashboardComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "all-companies",
    component: AllCompaniesComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "new-company",
    component: NewCompanyComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "edit-company/:companyId",
    component: EditCompanyComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "view-company/:companyId",
    component: ViewCompanyComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "all-users",
    component: AllUsersComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "all-admins",
    component: AllAdminsComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "new-user",
    component: NewUserComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "new-admin",
    component: NewAdminComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "view-user/:userId",
    component: ViewUserComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "view-admin/:userId",
    component: ViewAdminComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "edit-user/:userId",
    component: EditUserComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "edit-admin/:userId",
    component: EditAdminComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "credit-history/:userId",
    component: CreditHistoryComponent,
    canActivate: [AdminAuthGuardService],
  },
  {
    path: "print",
    component: PrintComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "new-print",
    component: NewPrintComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "new-print-media",
    component: NewPrintMediaComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "new-print-history",
    component: NewPrintHistoryComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
